import { enumify, Enumify } from '@mews/enumify';

function AlertType() {}

const config = {
    Info: 'alert-info',
    Success: 'alert-success',
    Warning: 'alert-warning',
    Error: 'alert-danger',
};

type Keys = keyof typeof config;
enumify<Keys, string>(AlertType, 'AlertType', config);

export default AlertType as unknown as Enumify<Keys, string>;
